import { Component } from '@angular/core';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { SessionService } from '../Util/Session/session.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ComboService } from '../Model/Combo/combo.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { FormsModule } from '@angular/forms';
import { CommonUploadComponent } from '../Component/CommonUpload/common-upload/common-upload.component';
import { AlertSuccessComponent } from '../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../Component/Alert/alert-warning/alert-warning.component';
import { CommonService } from '../Model/Common/common.service';

@Component({
  selector: 'app-cost-center-mapping',
  standalone: true,
  imports: [LoaderComponent, CommonModule, NgSelectModule, FormsModule, CommonUploadComponent],
  templateUrl: './cost-center-mapping.component.html',
  styleUrl: './cost-center-mapping.component.scss'
})
export class CostCenterMappingComponent {

  user: any;
  isDisabled: boolean = false
  BranchId: any = null;
  EmployeeId: any = null;
  CostCenterId: any = null;
  BranchLoad: any[] = [];
  EmployeesLoad: any[] = [];
  CostCenterLoad: any[] = [];

  Filter = {
    Date: '' as any,
    BranchId: null,
    ClientId: null,
    SiteId: null,
    EmpCode: '' as any
  }

  constructor(
    private comboload: ComboService,
    private session: SessionService,
    private modalService: NgbModal,
    private toast: ToastService,
    private common: CommonService
  ) {
    this.common.getPageRights();
    this.user = session.GetUserDetails();
  }

  async ngOnInit() {
    await this.ComboLoad('Branch');
  }

  FillCombo(Combotype: String) {
    this.isDisabled = true;
    this.comboload.ESS_AdditionalFillCombo({
      'SelectType': Combotype,
      'UserId': this.user.UserId,
      'BranchID': this.BranchId,
      'MonthName': '',
      'YearName': '',
    }).subscribe({
      next: (response) => {
        if (response.Table) {
          if (Combotype == 'BranchStaffForPosting') {
            this.EmployeesLoad = response.Table;
          }
          else if (Combotype == 'BranchStaffCostCenter') {
            this.CostCenterLoad = response.Table;
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    if (Combotype == 'Branch') {
      this.EmployeesLoad = [];
      this.EmployeeId = null;
      this.CostCenterLoad = [];
      this.CostCenterId = null;
    }
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'UserType': 'A',
      'BranchId': this.Filter.BranchId,
      'ClientId': this.Filter.ClientId,
      'SiteId': this.Filter.SiteId,
      'EmpType': 'front',
      'EmpCode': this.Filter.EmpCode
    }).subscribe({
      next: (response) => {
        if (response.ComboLoad) {
          if (Combotype == 'Branch') {
            this.BranchLoad = response.ComboLoad;
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  upload() {
    if (this.BranchId == null) {
      this.toast.show({ message: 'Kindly select Branch', type: toastTypeEnum.warning });
      return;
    }
    const modalRef = this.modalService.open(CommonUploadComponent, {
      size: 'lg',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Input_ExcelUploadMasterID = 7;
    modalRef.componentInstance.BranchId = this.BranchId;
    modalRef.result.then(result => {
    });
  }

  Save() {
    if (this.BranchId == null || this.EmployeeId == null || this.CostCenterId == null) {
      this.toast.show({ message: 'Select all mandatory fields', type: toastTypeEnum.warning });
      return;
    }
    this.isDisabled = true;
    this.comboload.StaffCostCenterUpdate({
      SelectType: 'U',
      BranchID: this.BranchId,
      EmpMasterID: this.EmployeeId,
      CostCenterCode: this.CostCenterId,
    }).subscribe({
      next: (response) => {
        if (response.Error_Code == "931") {
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.BranchId = null;
              this.EmployeeId = null;
              this.CostCenterId = null;
            }
          });
        } else {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => { });
        }
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    })

  }
}
